import { render, staticRenderFns } from "./FantasyNavigation.vue?vue&type=template&id=968272a0&scoped=true&"
import script from "./FantasyNavigation.vue?vue&type=script&lang=js&"
export * from "./FantasyNavigation.vue?vue&type=script&lang=js&"
import style0 from "./FantasyNavigation.vue?vue&type=style&index=0&id=968272a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968272a0",
  null
  
)

/* custom blocks */
import block0 from "./FantasyNavigation.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports